<app-dialog-container>
  <div fxLayout="column" fxLayoutGap="16px">
    <!-- Cabeçalho -->
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div>
        <h1 mat-dialog-title>{{ title }}</h1>
      </div>
      <div>
        <button *ngIf="type === typeCesEnum.EDIT" mat-icon-button
          (click)="changeType(typeCesEnum.SHOW)">
          <mat-icon class="btn-show">visibility</mat-icon>
        </button>
      </div>
    </div>
    <div fxLayout="column" fxFlex>
      <app-input class="image-content"
        [config]="getFieldConfig('image')"
        [typeCes]="type"
        [group]="form">
      </app-input>
    </div>

    <!-- Container dos campos -->
    <div fxLayout="column" fxLayoutGap="16px" fxFlex>

      <!-- Nome -->
      <div fxLayout="column" fxFlex>
        <app-input
          [config]="getFieldConfig('name')"
          [typeCes]="type"
          [group]="form"
          fxFlex>
        </app-input>
      </div>

      <div fxLayout="column" fxFlex>
        <app-input
          [config]="getFieldConfig('email')"
          [typeCes]="type"
          [group]="form"
          fxFlex>
        </app-input>
      </div>

      <!-- Tipo -->
      <div fxLayout="column" fxFlex>
        <app-input
          [config]="getFieldConfig('type')"
          [typeCes]="type"
          [group]="form"
          fxFlex>
        </app-input>
      </div>

      <!-- Vencimento -->
      <div fxLayout="column" fxFlex>
        <app-select
          [config]="getFieldConfig('dueDate')"
          [typeCes]="type"
          [group]="form"
          fxFlex>
        </app-select>
      </div>

      <!-- Sistema Pai (Condicional) -->
      <div fxLayout="column" fxFlex *ngIf="showParentSystemSelect">
        <app-input
          [config]="getFieldConfig('parentSystem')"
          [typeCes]="type"
          [group]="form"
          fxFlex>
        </app-input>
      </div>

      <app-input
        [config]="getFieldConfig('contractTemplate')"
        [typeCes]="isAllowChangeContract()"
        [group]="form"
        fxFlex>
      </app-input>
    </div>

    <!-- Botões de ação -->
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
      <button
        mat-raised-button
        color="primary"
        [disabled]="!form.valid"
        (click)="onSubmit(form.value)">
        Salvar
      </button>
    </div>
  </div>
</app-dialog-container>
